import React, { useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from 'components/Styled/Button/Button';
import RoomProvider from 'components/Provider/RoomProvider';
import SocketProvider from 'components/Provider/SocketProvider';
import { joinRoom } from 'services/socketEmitEvent';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 100,
    },
    replayBtn : {
        width: 200,
        float: 'right',
        margin: '10px!important'
    }
});

function WinnerBoard() {
    const classes = useStyles();
    const { room } = useContext(RoomProvider);
    const { socket } = useContext(SocketProvider);

    const winners = room.players.filter(p=>p.win);

    const handleReplay = () => {
        socket.connect();
        joinRoom(socket, room.name, room.localPlayer.name);
    }

    return (
        <TableContainer component={Paper}>
            <h1 align="center">Partie terminée !</h1>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">Vainqueurs</StyledTableCell>
                        <StyledTableCell align="center">Rôles</StyledTableCell>
                        <StyledTableCell align="center">Diamants</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {winners.map((player) => (
                        <StyledTableRow key={player.name}>
                            <StyledTableCell align="center">{player.name}</StyledTableCell>
                            <StyledTableCell align="center">{player.role.title}</StyledTableCell>
                            <StyledTableCell align="center">{player.diamondCount}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
            <Button
                className={classes.replayBtn}
                fullWidth={false}
                onClick={handleReplay}
            >
                Rejouer une partie
            </Button>
        </TableContainer>
    );
}

export default WinnerBoard;